import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import webforms from './webforms/webforms.reducer';
import safetyDatabaseObservation from './safetyDatabaseObservation/safetyDatabaseObservation.reducer';
import safetyDatabaseInspection from './safetyDatabaseInspection/safetyDatabaseInspection.reducer';

const persistConfig = {
	key: 'root',
	storage,
	blacklist: ['webforms']
};

const rootReducer = combineReducers({
	safetyDatabaseObservation,
	safetyDatabaseInspection,
	webforms
});

export default persistReducer(persistConfig, rootReducer);
